function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 2c.267 0 .484.207.484.462v9.962l3.69-3.52a.5.5 0 01.684 0 .447.447 0 010 .653l-4.516 4.308A.496.496 0 018 14a.496.496 0 01-.342-.135L3.142 9.557a.447.447 0 010-.653.5.5 0 01.684 0l3.69 3.52V2.462C7.516 2.207 7.733 2 8 2z",
  fill: "#2D2D2D"
});
function SvgFlechaabajo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Flecha abajo.svg";
export { SvgFlechaabajo as ReactComponent };